import type { InjectionKey } from "vue";
import type { UiSettings } from "./plugin";
import type { UiPopoverContext } from "./components/UiPopover.vue";

export const UiContextKey = Symbol("UiContext") as InjectionKey<UiSettings>;

export const UiPopoverKey = Symbol(
  "UiPopover"
) as InjectionKey<UiPopoverContext>;
